import { render, staticRenderFns } from "./assistant-wig-preview.vue?vue&type=template&id=29c2b22f&scoped=true"
import script from "./assistant-wig-preview.vue?vue&type=script&lang=js"
export * from "./assistant-wig-preview.vue?vue&type=script&lang=js"
import style0 from "./assistant-wig-preview.vue?vue&type=style&index=0&id=29c2b22f&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29c2b22f",
  null
  
)

export default component.exports